import React from 'react';

import { CriteriaRender } from './CriteriaRender';
import { ProductConfigChanges } from '../../../../types';
import { FieldChange } from './FieldChange';
import { capitalizeFirstLetter } from '../../../../../../../formatters';

const PRODUCT_CONFIG_FIELDS: Array<string> = [
  'productName',
  'productType',
  'externalId',
  'productCategory',
  'productDescriptionInternal',
  'productDescriptionExternal',
  'aftermarketVendorApiChannel',
];

interface ProductConfigRenderProps {
  changes: ProductConfigChanges;
}

export const ProductConfigRender = ({ changes }: ProductConfigRenderProps) => {
  return Object.entries(changes).map(([key, value]) => {
    if (PRODUCT_CONFIG_FIELDS.includes(key)) {
      return <FieldChange key={key} label={capitalizeFirstLetter(key)} before={value.before} after={value.after} />;
    }

    if (key === 'criteria') {
      return (
        <CriteriaRender
          key={key}
          before={value.before as Record<string, unknown> | null}
          after={value.after as Record<string, unknown> | null}
        />
      );
    }
  });
};
